import React from "react";

function GradeComponent({ grade, index }) {
    return (
        <p>
            Test {index}: {grade}%
        </p>
    );
}

export default GradeComponent;
